import React, { useMemo } from "react";
import { useAccount } from "wagmi";
import { useEthereum } from "../../contexts/etherruemContext";
import { shortenAddress } from "../../utils/formatter";
import config from "../../config";
import { useUnifiedWallet } from "../../providers/UnifiedWalletProvider";

interface Props {
  onClickWallet: () => void;
}

const chains = config.networks;

const WalletConnectButton: React.FC<Props> = ({ onClickWallet }) => {
  const ethereum = useEthereum();
  const { chain } = useUnifiedWallet();
  const { address, isConnected, status } = useAccount();

  const chainsList = useMemo(() => {
    return {
      ...chains,
    };
  }, [chains]);

  const isConnectWallet = isConnected && !!address;

  const walletAddress = address ? shortenAddress(address) : "Connect Wallet";

  const isShowWrongNetWork = useMemo(() => {
    return !(chainsList as any)[chain.chainId];
  }, [chainsList, chain]);

  const buttonClass = useMemo(() => {
    return isShowWrongNetWork && ethereum.isConnected
      ? "bg-evry-yellow"
      : "bg-gradient-to-tr from-velo-orange to-velo-pink";
  }, [isShowWrongNetWork, ethereum.isConnected]);

  return (
    <div
      className={`h-8 w-[160px] rounded-[2px] p-px cursor-pointer transition-all ${buttonClass}`}
      onClick={onClickWallet}
    >
      <div className="px-0 bg-velo-bg rounded-[2px] h-full w-full">
        {!isConnectWallet ? (
          <div className="px-0 w-full h-full flex flex-nowrap items-center justify-center">
            <p className="block text-sm text-white">
              {status === "connecting" || status === "reconnecting"
                ? "Connecting..."
                : "Connect Wallet"}
            </p>
          </div>
        ) : isShowWrongNetWork ? (
          <div className="min-w-[36px] w-full h-full flex flex-nowrap justify-center items-center">
            <p className="font-semibold block text-sm text-white">
              {walletAddress}
            </p>
          </div>
        ) : (
          <div className="min-w-[36px] w-full h-full flex flex-nowrap justify-center items-center">
            <img
              className="w-6 mr-2"
              src={config.networks[config.chainId]?.image || ""}
              alt="wallet-icon"
            />
            <p className="font-semibold block text-sm text-white">
              {walletAddress}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default WalletConnectButton;
